import { render, staticRenderFns } from "./IntroScreen.vue?vue&type=template&id=818ac92e&scoped=true&lang=pug&"
import script from "./IntroScreen.vue?vue&type=script&lang=js&"
export * from "./IntroScreen.vue?vue&type=script&lang=js&"
import style0 from "./IntroScreen.vue?vue&type=style&index=0&id=818ac92e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818ac92e",
  null
  
)

export default component.exports